import React from 'react'
import { useFormik } from 'formik'

import { Wrap, Input, Button } from './styled'

import { LoadingIcon } from 'src/components/Icons'

interface Props {
  onSubmit: (values: { emailOrUsername: string }) => void
  isLoading: boolean
}

export const InviteInput: React.FC<Props> = ({ onSubmit, isLoading }) => {
  const form = useFormik({
    initialValues: {
      emailOrUsername: '',
    },
    onSubmit: (values) => {
      onSubmit(values)
    },
  })
  return (
    <Wrap onSubmit={form.handleSubmit}>
      <Input
        name="emailOrUsername"
        value={form.values.emailOrUsername}
        onChange={form.handleChange}
        placeholder="Enter username or email"
        disabled={isLoading}
      />
      <Button disabled={isLoading} type="submit">
        {isLoading ? <LoadingIcon /> : 'Invite'}
      </Button>
    </Wrap>
  )
}
